import {
  Autocomplete,
  Button,
  FormLabel,
  ListItemContent,
  Modal,
  ModalDialog,
} from "@mui/joy";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";

interface DisciplineCodesAddModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data:any) => void;
  values: any[];
  options: any[];
}

const DisciplineCodesAddModal = ({
    values,
    isOpen,
    onClose,
    onSave,
    options,
  }: DisciplineCodesAddModalProps) => {
    const [selectedItems, setSelectedItems] = useState<Record<string, any | null>>(
      {}
    );
    const [filteredOptionsSubCategories, setFilteredOptionsSubCategories] = useState<any[]>([]);
    const [filteredOptionsTypes, setFilteredOptionsTypes] = useState<any[]>([]);
    const [filteredOptionsSubTypes, setFilteredOptionsSubTypes] = useState<any[]>([]);

    const [categories, setCategories] = useState<any[]>([]);
    const [subCategories, setSubCategories] = useState<any[]>([]);
    const [types, setTypes] = useState<any[]>([]);
    const [subTypes, setSubTypes] = useState<any[]>([]);

      // Nieuwe state toegevoegd om de geselecteerde waarden van Autocomplete bij te houden
  const [autocompleteValues, setAutocompleteValues] = useState<Record<string, any | null>>({
    'category': null,
    'subCategory': null,
    'type': null,
    'subType': null,
  });
  
    useEffect(() => {
      setCategories(options.filter((a: any) => a.code.length === 2));
      setSubCategories(options.filter((a: any) => a.code.length === 4));
      setTypes(options.filter((a: any) => a.code.length === 6));
      setSubTypes(options.filter((a: any) => a.code.length === 8));
    }, [values]);
  
    const handleInputChangeCategories = (value: any | null) => {
      // Filter subcategories based on the selected categoryw

      const filteredSubCategories = subCategories.filter(
        (subcategory) => subcategory.parent === value?.id
      );
      // reset filter if value is null
      setFilteredOptionsSubCategories(filteredSubCategories);
  
      // Update the selected category in state
      setSelectedItems((prevItems) => ({ ...prevItems, 'category': value }));
      //setAutocompleteValues((prevValues) => ({ ...prevValues, 'category': value }));
      

      // Clear values for dependent fields
      setSelectedItems((prevItems) => ({
        ...prevItems,
        'subCategory': null,
        'type': null,
        'subType': null,
      }));
    };
  
    const handleInputChangeSubCategories = (value: any | null) => {
      // Filter types based on the selected subcategory
      console.log("value", value);
      console.log("trigger handle");
      const filteredTypes = types.filter(
        (type) => type.parent === value?.id
      );
      setFilteredOptionsTypes(filteredTypes);
  
      // Update the selected subcategory in state
      setSelectedItems((prevItems) => ({ ...prevItems, 'subCategory': value }));
      //setAutocompleteValues((prevValues) => ({ ...prevValues, 'subCategory': value }));
      // Clear values for dependent fields
      setSelectedItems((prevItems) => ({
        ...prevItems,
        'type': null,
        'subType': null,
      }));
    };
  
    const handleInputChangeTypes = (value: any | null) => {
      // Filter subtypes based on the selected type
      const filteredSubTypes = subTypes.filter(
        (subType) => subType.parent === value?.id
      );

      setFilteredOptionsSubTypes(filteredSubTypes);
  
      // Update the selected type in state
      setSelectedItems((prevItems) => ({ ...prevItems, 'type': value }));
      //setAutocompleteValues((prevValues) => ({ ...prevValues, 'type': value }));
      // Clear values for dependent fields
      setSelectedItems((prevItems) => ({
        ...prevItems,
        'subType': null,
      }));
    };
  
    const handleInputChangeSubTypes = (value: any | null) => {
      // Update the selected subtype in state
      setSelectedItems((prevItems) => ({ ...prevItems, 'subType': value }));
      //setAutocompleteValues((prevValues) => ({ ...prevValues, 'subType': value }));
    };
  
    const handleSave = () => {
      // Your save logic here
      onSave(selectedItems);
    };
  
    return (
      <Modal open={isOpen} onClose={onClose}>
        <React.Fragment>
          <ModalDialog>
            <form>
              {/* Categories */}
              <FormLabel sx={{ marginTop: '1rem', paddingBottom: '0.5rem' }}>
                Categories
              </FormLabel>
              <Autocomplete
                sx={{ width: 600 }}
                options={categories}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                //value={autocompleteValues['category']}
                renderOption={(props, option) => (
                  <div
                    key={option.id}
                    {...(props as React.HTMLAttributes<HTMLDivElement>)}
                  >
                    <ListItemContent sx={{ fontSize: 'sm' }}>
                      {option.name}
                    </ListItemContent>
                  </div>
                )}
                onChange={(event, value) =>
                  handleInputChangeCategories(value)
                }
                
              />
  
              {/* Sub Categories */}
              <FormLabel sx={{ marginTop: '1rem', paddingBottom: '0.5rem' }}>
                Sub Categories
              </FormLabel>
              <Autocomplete
                sx={{ width: 600 }}
                options={filteredOptionsSubCategories}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                //value={autocompleteValues['subCategory']}
                renderOption={(props, option) => (
                  <div
                    key={option.id}
                    {...(props as React.HTMLAttributes<HTMLDivElement>)}
                  >
                    <ListItemContent sx={{ fontSize: 'sm' }}>
                      {option.name}
                    </ListItemContent>
                  </div>
                )}
                onChange={(event, value) =>
                  handleInputChangeSubCategories(value)
                }
              />
  
              {/* Types */}
              <FormLabel sx={{ marginTop: '1rem', paddingBottom: '0.5rem' }}>
                Type
              </FormLabel>
              <Autocomplete
                sx={{ width: 600 }}
                options={filteredOptionsTypes}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                //value={autocompleteValues['type']}
                renderOption={(props, option) => (
                  <div
                    key={option.id}
                    {...(props as React.HTMLAttributes<HTMLDivElement>)}
                  >
                    <ListItemContent sx={{ fontSize: 'sm' }}>
                      {option.name}
                    </ListItemContent>
                  </div>
                )}
                onChange={(event, value) => handleInputChangeTypes(value)}
              />
  
              {/* Sub Types */}
              <FormLabel sx={{ marginTop: '1rem', paddingBottom: '0.5rem' }}>
                Sub Types
              </FormLabel>
              <Autocomplete
                sx={{ width: 600 }}
                options={filteredOptionsSubTypes}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                //value={autocompleteValues['subType']}
                renderOption={(props, option) => (
                  <div
                    key={option.id}
                    {...(props as React.HTMLAttributes<HTMLDivElement>)}
                  >
                    <ListItemContent sx={{ fontSize: 'sm' }}>
                      {option.name}
                    </ListItemContent>
                  </div>
                )}
                onChange={(event, value) => handleInputChangeSubTypes(value)}
              />
  
              {/* Save and Close Buttons */}
              <Button
                id="addButton"
                variant="outlined"
                color="neutral"
                sx={{ backgroundColor: '#484494' }}
                type="button"
                onClick={handleSave}
              >
                Toevoegen
              </Button>
              <Button
                id="addButton"
                variant="outlined"
                color="neutral"
                sx={{ backgroundColor: '#484494', marginTop: '1rem' }}
                type="button"
                onClick={onClose}
              >
                Afsluiten
              </Button>
            </form>
          </ModalDialog>
          <ToastContainer />
        </React.Fragment>
      </Modal>
    );
  };
  
  export default DisciplineCodesAddModal;
